export const projeler = {
  title: 'Projeler',
  titleEN: 'Projects',
  description: 'Mynet.com\’da yayınlanan liste ve quiz içeriklerinden farklı olarak, teknik, tasarım ve content ekiplerinin çalışması sonucu oluşturulan, temel amacı marka ve kampanya bilinirliği arttırmak olan kullanıcı etkileşimli kurgulardır.',
  descriptionEN: 'Unlike the list and quiz content published on Mynet.com, these are user-interactive designs created through the collaboration of technical, design, and content teams, with the primary goal of increasing brand and campaign awareness.',
  tabs: [
    {
      id: 1,
      title: 'Content Interaction Project',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/df6c7b846a9b610703b9e4055d868c6538cc87bd4571177500058bdf13e74051.png',
          modal: 'image',
          modalTitle: 'Samsung',
          category: 'Samsung'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/61f0da00ced2e8ffe1eed2689b2d9777408db0b4ff5a3b02e0be951f2e43992f.png',
          modal: 'image',
          modalTitle: 'MediaMarkt Anne Al',
          category: 'MediaMarkt Anne Al'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/beab9a69dd629710768d5e67a7cc529da6478217a9030831c06351962546704d.png',
          url: 'https://finans.mynet.com/?google_preview=Uym9SpabivoYiqnXxAYwisWMzAaIAYCAgJC89uvIowE&iu=28687765&gdfp_req=1&lineItemId=6860603408&creativeId=138500400619',
          category: 'Levis 501 Masthead'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/27a7f4b85f4b81e067bc072230019cebf91b940dcf86f3bd3a82d054bdb8790d.png',
          url: 'http://finans.mynet.com?google_preview=k-VJXpWrzQoY9abXxAYw9cKMzAaIAYCAgJC89vPH2wE&iu=28687765&gdfp_req=1&lineItemId=6515218471&creativeId=138465793606',
          category: 'Minbee Takeover'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8ab9772d7526c8ec953984acd9652439e27a3d4cd6daa66229ee27c42ba71870.png',
          url: 'https://finans.mynet.com/?google_preview=seRSaTY6MPQYv6jXxAYwv8SMzAaIAYCAgJC89ovWOQ&iu=28687765&gdfp_req=1&lineItemId=6860603408&creativeId=138500400418',
          category: 'Getir Çarşı Masthead'
        }
      ]
    },
    {
      id: 3,
      title: 'Special Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/939defe2256f107f3579dbb621465afb142b26fe05e8d2fbd6513343c7c24590.png',
          url: 'https://www.mynet.com/trend/tatil-bulucu',
          category: 'Mynet Tatil Bulucu'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8d2c488824cce00f3fb5e4c46edb6b984edf3f2ae72a2aeea93f57ee69ff87df.png',
          url: 'https://www.mynet.com/kadin/soran-anne-platformu',
          category: 'Soran Anne GPT'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Content Interaction Project',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          image: 'https://srv-cdn.onedio.com/store/df6c7b846a9b610703b9e4055d868c6538cc87bd4571177500058bdf13e74051.png',
          modal: 'image',
          modalTitle: 'Samsung',
          category: 'Samsung'
        },
        {
          id: 2,
          image: 'https://srv-cdn.onedio.com/store/61f0da00ced2e8ffe1eed2689b2d9777408db0b4ff5a3b02e0be951f2e43992f.png',
          modal: 'image',
          modalTitle: 'MediaMarkt Anne Al',
          category: 'MediaMarkt Anne Al'
        }
      ]
    },
    {
      id: 2,
      title: 'Rich Media',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/beab9a69dd629710768d5e67a7cc529da6478217a9030831c06351962546704d.png',
          url: 'https://finans.mynet.com/?google_preview=Uym9SpabivoYiqnXxAYwisWMzAaIAYCAgJC89uvIowE&iu=28687765&gdfp_req=1&lineItemId=6860603408&creativeId=138500400619',
          category: 'Levis 501 Masthead'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/27a7f4b85f4b81e067bc072230019cebf91b940dcf86f3bd3a82d054bdb8790d.png',
          url: 'http://finans.mynet.com?google_preview=k-VJXpWrzQoY9abXxAYw9cKMzAaIAYCAgJC89vPH2wE&iu=28687765&gdfp_req=1&lineItemId=6515218471&creativeId=138465793606',
          category: 'Minbee Takeover'
        },
        {
          id: 3,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8ab9772d7526c8ec953984acd9652439e27a3d4cd6daa66229ee27c42ba71870.png',
          url: 'https://finans.mynet.com/?google_preview=seRSaTY6MPQYv6jXxAYwv8SMzAaIAYCAgJC89ovWOQ&iu=28687765&gdfp_req=1&lineItemId=6860603408&creativeId=138500400418',
          category: 'Getir Çarşı Masthead'
        }
      ]
    },
    {
      id: 3,
      title: 'Special Projects',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/939defe2256f107f3579dbb621465afb142b26fe05e8d2fbd6513343c7c24590.png',
          url: 'https://www.mynet.com/trend/tatil-bulucu',
          category: 'Mynet Tatil Bulucu'
        },
        {
          id: 2,
          name: '',
          image: 'https://srv-cdn.onedio.com/store/8d2c488824cce00f3fb5e4c46edb6b984edf3f2ae72a2aeea93f57ee69ff87df.png',
          url: 'https://www.mynet.com/kadin/soran-anne-platformu',
          category: 'Soran Anne GPT'
        }
      ]
    }
  ],
}


